import amazon from './amazon'
import netflix from './netflix'
import linkedin from './linkedin'

export default {
  netflix,
  amazon,
  linkedin
}
